import * as React from 'react'
import PropTypes from 'prop-types'
import TreeView from '@mui/lab/TreeView'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import TreeItem from '@mui/lab/TreeItem'
import {useTreeItem}  from '@mui/lab/TreeItem'
import clsx from 'clsx'
import Typography from '@mui/material/Typography'
import { IconButton } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
const CustomContent = React.forwardRef(function CustomContent(props, ref) {
  const {
    classes,
    className,
    customClass,
    label,
    nodeId,
    icon: iconProp,
    expansionIcon,
    displayIcon,
    handledelete,
  } = props

  const { disabled, expanded, selected, focused, handleExpansion, handleSelection, preventSelection } =
    useTreeItem(nodeId)

  const icon = iconProp || expansionIcon || displayIcon

  const handleMouseDown = (event) => {
    preventSelection(event)
  }

  const handleExpansionClick = (event) => {
    handleExpansion(event)
  }

  const handleSelectionClick = (event) => {
    handleSelection(event)
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={clsx(className, classes.root, {
        [classes.expanded]: expanded,
        [classes.selected]: selected,
        [classes.focused]: focused,
        [classes.disabled]: disabled,
      })}
      onMouseDown={handleMouseDown}
      ref={ref}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div onClick={handleExpansionClick} className={classes.iconContainer}>
        {icon}
      </div>

      <Typography onClick={handleSelectionClick} component='div' className={classes.label}>
        {label}
      </Typography>
      <IconButton size='small' onClick={() => handledelete(nodeId)}>
        <DeleteOutlineIcon fontSize='small' />
      </IconButton>
    </div>
  )
})

CustomContent.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  /**
   * className applied to the root element.
   */
  className: PropTypes.string,
  /**
   * The icon to display next to the tree node's label. Either a parent or end icon.
   */
  displayIcon: PropTypes.node,
  /**
   * The icon to display next to the tree node's label. Either an expansion or collapse icon.
   */
  expansionIcon: PropTypes.node,
  /**
   * The icon to display next to the tree node's label.
   */
  icon: PropTypes.node,
  /**
   * The tree node label.
   */
  label: PropTypes.node,
  /**
   * The id of the node.
   */
  nodeId: PropTypes.string.isRequired,
}

export const CustomTreeItem = (props) => (
  <TreeItem
    ContentProps={{
      handledelete: props.handledelete,
    }}
    ContentComponent={CustomContent}
    label={props.label}
    nodeId={props.nodeId}
    className={props.customClass}
    // {...props}
  />
)
